import { isProfileCompleteAllowed } from './guard'

export const guardHelper = {
  isProfileCompleteAllowed,
}
